module.exports = __webpack_public_path__ + "img/20-1.fe678b25.jpg";